"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropTypes = void 0;
var anything = function () { return null; };
exports.PropTypes = {
    anything: anything,
};
